// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Div, H3, InlineDiv, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import { formatAverageRating } from '../../helpers/common-helpers';
import RatingStars from '../RatingStars/RatingStars';

// Other

// Component
const RatingMedium = ({
  averageRating,
  reviewsCount,
  sourcesCount,
  inlineRatingStars,
}) => (
  <Div>
    <H3
      color={colors.charcoal}
      margin="0"
      display={inlineRatingStars && 'inline-flex'}
    >
      <RatingStars averageRating={averageRating} sideLength="20px" />
      <div aria-hidden>
        <InlineDiv>{formatAverageRating(averageRating)}</InlineDiv>
        <InlineDiv color={colors.slate}> / 5</InlineDiv>
      </div>
    </H3>
    <P color={colors.slate}>
      {reviewsCount} Reviews{' '}
      {sourcesCount !== undefined
        && `from ${sourcesCount} source${sourcesCount !== 1 ? 's' : ''}`}
    </P>
  </Div>
);
RatingMedium.propTypes = {
  sourcesCount: PropTypes.number,
  averageRating: PropTypes.number,
  reviewsCount: PropTypes.number,
  inlineRatingStars: PropTypes.bool,
};

export default RatingMedium;
